import { account } from "./account"
import { common } from "./common"
import { credits } from "./credits"
import { dictionary } from "./dictionary"
import { header } from "./header"
import { main } from "./main"
import { planner } from "./planner"
import { timetable } from "./timetable"
import { writeReviews } from "./writeReviews"

export const i18nEn = {
    account,
    common,
    credits,
    dictionary,
    header,
    main,
    planner,
    writeReviews,
    timetable,
}
